export default {
    contractList: {
        title: 'Aktivni ugovori',
        newContractAria: 'Stvori novi ugovor',
        loadErrorTitle: 'Nije moguće učitati ugovore',
        loadErrorBody: 'Mrežna pogreška — pokušajte ponovno',
        tryAgain: 'Pokušaj ponovno',
        emptyTitle: 'Nema aktivnih ugovora',
        emptyBody: 'Stvorite svoj prvi ugovor pomoću obrasca s desne strane.',
        emptyCta: 'Stvorite svoj prvi ugovor',
        filterEmptyTitle: 'Nijedan ugovor ne odgovara ovim filtrima',
        filterEmptyBody: 'Pokušajte ukloniti filtar ili proširiti raspon datuma.',
        clearFilters: 'Očisti filtre',
    },
}
